<script lang="ts">
	interface Props {
		color?: string // Default color
		height?: string // Default height
		width?: string // Default width
		class?: string
	}

	let {
		color = '#000000',
		height = '48px',
		width = '48px',
		class: className = '',
	}: Props = $props()
</script>

<svg
	fill="none"
	viewBox="0 0 48 48"
	{height}
	{width}
	class={className}
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-width="2"
		d="M6 18a4 4 0 014-4h1.86a4 4 0 003.328-1.78l1.624-2.44A4 4 0 0120.14 8h7.72a4 4 0 003.328 1.78l1.624 2.44A4 4 0 0036.14 14H38a4 4 0 014 4v18a4 4 0 01-4 4H10a4 4 0 01-4-4V18z"
	/>
	<path
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-width="2"
		d="M30 26a6 6 0 11-12 0 6 6 0 0112 0z"
	/>
</svg>
